import { Industry } from "@/@types/index"
import { IndustrieResponse } from "../industries/models/IndustrieResponse"

export function mapIndustrie(industrie: IndustrieResponse): Industry {
  return {
    id: industrie.id,
    image: industrie.image,
    image_description: industrie.image_description,
    title: industrie.title,
    order: industrie.order,
    slug: industrie.slug,
    status_id: industrie.status_id
  }
}